import { render } from "./CreateAppModal.vue?vue&type=template&id=9d4a844a&scoped=true"
import script from "./CreateAppModal.vue?vue&type=script&lang=ts"
export * from "./CreateAppModal.vue?vue&type=script&lang=ts"

import "./CreateAppModal.vue?vue&type=style&index=0&id=9d4a844a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9d4a844a"

export default script